export const parseStaticAppName = () => window.location.pathname.match(/^\/([^/]+)\/v\//)?.[1] || ''
export const isOnStaticSandbox = () => parseStaticAppName() !== ''

// The BASE_URL is its unique version ID.
// However, based on what URL the user is currently hitting,
// we may want the base URL to change.
// If the user is just viewing the root location (static-build.govhub.com),
// the base URL should be nothing.
// If the user is looking at a specific version, then the base URL
// should contain that version.
// If the version the user is looking at is current, we should keep it as current.
export const currentBaseUrl = () => {
  const staticAppName = parseStaticAppName()
  if (staticAppName) {
    return window.location.pathname.includes(`/${staticAppName}/v/current`) ? `/${staticAppName}/v/current/` : process.env.BASE_URL || '/'
  }
  return '/'
}
